import React from "react";

export const WEAVER_LOGO_SRC = `${process.env.PUBLIC_URL}/logos/weaver-media.png`;
export const WEAVER_MARK_SRC = `${process.env.PUBLIC_URL}/logos/weaver-mark.png`;

const sizeClasses = {
  sm: "text-base sm:text-lg",
  md: "text-lg sm:text-xl",
  lg: "text-2xl sm:text-3xl",
  xl: "text-[1.7rem] sm:text-5xl",
};

const imageSizeClasses = {
  sm: "h-10 sm:h-12",
  md: "h-12 sm:h-14",
  lg: "h-20 sm:h-24",
  xl: "h-56 sm:h-72 md:h-80",
};

export const WeaverLogo = ({
  className = "",
  size = "md",
  variant = "text",
  withMark = false,
  "data-testid": testId,
}) => {
  if (variant === "image") {
    return (
      <img
        src={WEAVER_LOGO_SRC}
        alt="Weaver Media"
        className={`${imageSizeClasses[size] || imageSizeClasses.md} w-auto object-contain select-none invert brightness-110 ${className}`}
        data-testid={testId}
        draggable={false}
      />
    );
  }

  return (
    <div
      className={`weaver-logo inline-flex items-baseline ${sizeClasses[size] || sizeClasses.md} ${className}`}
      data-testid={testId}
      aria-label="Weaver Media"
    >
      {withMark && (
        <img
          src={WEAVER_MARK_SRC}
          alt=""
          aria-hidden="true"
          className="h-[1.15em] w-auto self-center mr-4 select-none"
          draggable={false}
        />
      )}
      <span className="text-white">WEAVER</span>
      <span className="accent text-zinc-400">MEDIA</span>
    </div>
  );
};

export default WeaverLogo;
